export const MODE_OPTIONS = [
  { id: 1015, type: '枪战对决', num: 1 },
  { id: 1053, type: '迷你特训', num: 2 },
  { id: 1060, type: '枪战对决', num: 1 },
  { id: 1024, type: '枪战对决', num: 1 },
  { id: 1043, type: '枪战对决', num: 1 },
  { id: 1072, type: '枪战对决', num: 1 },
  { id: 1038, type: '枪战对决', num: 1 },
  { id: 1008, type: '枪战对决', num: 1 },
  { id: 1067, type: '迷你特训', num: 2 },
  { id: 1066, type: '迷你特训', num: 2 },
  { id: 1012, type: '枪战对决', num: 1 },
  { id: 1039, type: '枪战对决', num: 1 },
  { id: 1058, type: '迷你特训', num: 2 },
  { id: 1023, type: '枪战对决', num: 1 },
  { id: 1052, type: '迷你特训', num: 2 },
  { id: 2002, type: '枪战对决', num: 1 },
  { id: 1044, type: '枪战对决', num: 1 },
  { id: 1059, type: '迷你特训', num: 2 },
  { id: 2001, type: '枪战对决', num: 1 },
  { id: 2007, type: '迷你特训', num: 2 },
  { id: 1036, type: '枪战对决', num: 1 },
  { id: 1004, type: '枪战对决', num: 1 },
  { id: 1017, type: '枪战对决', num: 1 },
  { id: 1001, type: '枪战对决', num: 1 },
  { id: 2003, type: '枪战对决', num: 1 },
  { id: 1037, type: '枪战对决', num: 1 },
  { id: 1020, type: '枪战对决', num: 1 },
  { id: 1075, type: '枪战对决', num: 1 },
  { id: 1070, type: '迷你特训', num: 2 },
  { id: 1029, type: '野人突变', num: 3},
  { id: 1042, type: '野人突变', num: 3},
  { id: 1062, type: '野人突变', num: 3},
  { id: 2009, type: '迷你特训', num: 2 },
  { id: 1064, type: '枪战对决', num: 1 },
  { id: 1056, type: '迷你特训', num: 2 },
  { id: 2008, type: '迷你特训', num: 2 },
  { id: 1034, type: '枪战对决', num: 1 },
  { id: 1032, type: '枪战对决', num: 1 },
  { id: 1057, type: '迷你特训', num: 2 },
  { id: 1040, type: '枪战对决', num: 1 },
  { id: 1026, type: '枪战对决', num: 1 },
  { id: 1022, type: '枪战对决', num: 1 },
  { id: 1061, type: '枪战对决', num: 1 },
  { id: 1041, type: '野人突变', num: 3},
  { id: 1003, type: '枪战对决', num: 1 },
  { id: 1063, type: '枪战对决', num: 1 },
  { id: 1021, type: '枪战对决', num: 1 },
  { id: 2005, type: '枪战对决', num: 1 },
  { id: 1025, type: '枪战对决', num: 1 },
]